/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Action } from '@ngrx/store';

export const WRITE_JWT_TOKENS = '[AUTH] WRITE_JWT_TOKENS';

export class WriteJwtGlobally implements Action {
  readonly type = WRITE_JWT_TOKENS;
  constructor(public payload: string) {}
}

export type Actions = WriteJwtGlobally;
/* PavCon, LLC Proprietary.All rights reserved 2022 */
